import { CanActivateFn, Router } from '@angular/router';
import { BootstrapService } from '@core/bootstrap/bootstrap.service';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CRouteList } from '@app/route-list.const';
import { LoggerService } from '../logger/logger.service';

/**
 * Start the bootstrap at the parent component level so that route params are available in activated route
 * The guard ensures that bootstrap is fully completed before any child components are loaded and handles redirects on fatal errors
 */
export const isAppInitialized: CanActivateFn = async (route): Promise<boolean> => {
  const bootstrapService = inject(BootstrapService);
  const router = inject(Router);
  const logger = inject(LoggerService);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getErrorMessage = (e: any) => {
    return e?.error?.message || e?.message || e?.error || e;
  };

  try {
    await firstValueFrom(bootstrapService.bootstrapApplication(route));
    return true;
  } catch (e) {
    logger.warn(`Error on application bootstrap: ${getErrorMessage(e)}`);
    bootstrapService.setIsLoading(false);
    await router.navigate([CRouteList.error]);
    return false;
  }
};
